export type EffectiveTripRole = "owner" | "traveller" | "participant" | "viewer";

export function normalizeTripRole(value: unknown, isOwner = false): EffectiveTripRole {
  if (isOwner) return "owner";
  const role = String(value || "").toLowerCase();
  if (role === "owner") return "owner";
  if (role === "traveller" || role === "traveler") return "traveller";
  if (role === "participant" || role === "editor") return "participant";
  return "viewer";
}

export function canEditTripContent(role: EffectiveTripRole): boolean {
  return role === "owner" || role === "traveller" || role === "participant";
}

export function canManageParticipants(role: EffectiveTripRole): boolean {
  return role === "owner";
}

export function canAdminTrip(role: EffectiveTripRole): boolean {
  return role === "owner" || role === "traveller";
}

export function canDeleteTrip(role: EffectiveTripRole): boolean {
  return role === "owner";
}
